import axios from 'axios';
import store  from '../store/Store';


import {  signInWithRedirect,signOut,fetchUserAttributes,fetchAuthSession } from '@aws-amplify/auth';
import { useDispatch } from 'react-redux';
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_DIAGRAM, // Change to your API base URL
    headers: { 'Content-Type': 'application/json' }
});

  
axiosInstance.interceptors.request.use(
    
    async (config) => {
        let token = store.getState().userContext.user.token;
        if (!token){
            // const attr = await fetchUserAttributes();
            try{
                const session = await fetchAuthSession();
                token = session.tokens.idToken.toString();
            }catch(err){
                console.log('error during getting the token',err);
                await signOut(); 
                await signInWithRedirect();
            }
            
        }
        
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

// Add a response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401) {
            await signOut(); 
            await signInWithRedirect();
        }
        
        return Promise.reject(error);
    }
);

export default axiosInstance;
